(function () {
	'use strict';
	angular.module('app.core')
		.service('factoryColumns', factoryColumns);

	factoryColumns.$inject = ['tableRenderService'];
	function factoryColumns(tableRenderService) {
		return [{
			id: 'factoryName',
			display: 'Site',
			width: 100,
			sort: true
		},{
			id: 'factoryAlias',
			display: 'Site',
			width: 100,
			sort: true
		},{
			id: 'businessUnit',
			display: 'Business Unit',
			width: 100,
			sort: true
		},{
			id: 'division',
			display: 'Division',
			width: 100,
			sort: true
		},{
			id: 'entity',
			display: 'Entity',
			width: 100,
			sort: true
		}];
	};
})();